import * as orderActions from 'actions/orderActions';

const ORDER_DEFAULT_PAGE = 0;
const ORDER_DEFAULT_PAGE_SIZE = 10;

const initialState = {
  success: false,
  pending: true,
  error: '',
  // Current page of orders (server-side pagination)
  data: [],
  item: null,

  // Pagination + filtering state (server-driven)
  page: ORDER_DEFAULT_PAGE,
  pageSize: ORDER_DEFAULT_PAGE_SIZE,
  totalOrders: 0,
  query: '',
  filter: {
    status: '',
    amount: [0, 0]
  },

  // Aggregated totals for the Overview dashboard (from GET /orders/stats)
  stats: {
    totalRevenue: 0,
    totalOrders: 0,
    mostOrderedProductId: '',
    mostOrderedProduct: null
  }
};

const orderReducer = (state = initialState, action) => {
  switch (action.type) {
    case orderActions.ORDER_LIST_REQUEST:
      return {
        ...state,
        success: false,
        pending: true
      };
    case orderActions.ORDER_ID_REQUEST:
    case orderActions.ORDER_STATUS_UPDATE_REQUEST:
    case orderActions.ORDER_UPDATE_REQUEST:
      return {
        ...state,
        success: false,
        pending: true,
        item: null,
      };
    case orderActions.ORDER_ERROR:
      return {
        ...state,
        success: false,
        pending: false,
        error: action.message
      };
    case orderActions.ORDER_LIST_SUCCESS:
      return {
        ...state,
        success: true,
        pending: false,
        data: action.data,
        totalOrders: action.count
      };
    case orderActions.ORDER_STATS_SUCCESS:
      return {
        ...state,
        stats: action.stats
      };
    case orderActions.ORDER_ID_SUCCESS:
    case orderActions.ORDER_STATUS_UPDATE_SUCCESS:
    case orderActions.ORDER_UPDATE_SUCCESS:
      return {
        ...state,
        success: true,
        pending: false,
        item: action.data
      };
    case orderActions.ORDER_CHANGE_PAGE:
      return {
        ...state,
        page: action.page
      };
    case orderActions.ORDER_CHANGE_PAGE_SIZE:
      return {
        ...state,
        pageSize: action.pageSize
      };
    case orderActions.ORDER_SEARCH_QUERY:
      return {
        ...state,
        query: action.query
      };
    case orderActions.ORDER_SET_FILTER:
      return {
        ...state,
        filter: {
          ...state.filter,
          ...action.filter
        }
      };
    case orderActions.ORDER_CLEAR_FILTER:
      return {
        ...state,
        filter: {
          ...initialState.filter
        }
      };
    default:
      return state;
  }
}

export default orderReducer;
